export const legal = {
  businessName: "DevNyx",
  responsiblePerson: "Kenan Sivro",
  address: {
    street: "Bruckenstr. 2",
    postalCode: "97828",
    city: "Marktheidenfeld",
    country: "Germany",
  },
  email: "kenan.sivro@gmail.com",
};

export const legalAddressLines = [
  legal.address.street,
  `${legal.address.postalCode} ${legal.address.city}`,
  legal.address.country,
];
